// paymentSuccessModalStyles

// Libs
import React, { useEffect } from 'react'
import styled, { css } from 'styled-components'

// Comps
import { Modal, Props as ModalProps } from './Modal'
import { H5, P, H3 } from '../Headings'
import { fadeIn } from '../../utils/keyframes'
import { colors, fontWeights, icons } from '../../utils'
import { Hyperlink } from '../Hyperlink'
import { CTA } from '../CTA'

export const paymentSuccessDivStyles = css`
  align-items: center;
  animation: ${fadeIn} 100ms ease;
  display: flex;
  justify-content: center;
  flex-direction: column;

  padding-top: 44px;
  padding-bottom: 44px;

  .header {
    width: 100%;
    margin-bottom: 33px;
    text-align: center;
  }

  .content {
    font-weight: ${fontWeights.normal};
    line-height: 130%;
    text-align: center;
    width: 458px;
    max-width: 90%;
    margin-bottom: 33px;
    color: ${colors.veryDarkGray};
  }

  .button {
    width: 263px;
    max-width: 90%;

    &.addToCalendarButton {
      margin-bottom: 20px;
    }
  }
`

export const paymentSuccessNotificationStyles = css`
  align-items: center;
  animation: ${fadeIn} 100ms ease;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: ${colors.purple};
  padding-top: 22px;
  padding-bottom: 22px;
  /* min-height: 84px; */
  /* max-height: 84px; */
  position: relative;
  padding-top: 44px;
  padding-bottom: 44px;

  margin-top: 20px;

  .header {
    width: 100%;
    max-width: 90%;
    margin: auto;
    text-align: center;
    color: ${colors.white};
    font-weight: ${fontWeights.semiBold};
    line-height: 130%;
  }

  .detail {
    width: 100%;
    max-width: 90%;
    margin: auto;
    text-align: center;
    color: ${colors.grey};
    .link {
      color: ${colors.whiteWithOpacity80};
    }
  }

  .closeDiv {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;

    & img {
      width: 100%;
      height: 100%;
    }
  }
`
